export default {
  'dashboard.analysis.title': '分析页',
  'dashboard.analysis.timeRange': '时间范围',
  'dashboard.analysis.visitData': '访问量',
  'dashboard.analysis.visits': '访问量',
  'dashboard.analysis.average': '平均访问量',
  'dashboard.analysis.volume': '访问量',
  'dashboard.analysis.conversion': '转化率',
  'dashboard.analysis.trend': '趋势',
  'dashboard.analysis.ranking': '排名',
  'dashboard.analysis.searchData': '搜索用户数',
  'dashboard.analysis.userPortrait': '用户画像',

  'dashboard.monitor.title': '监控页',
  'dashboard.monitor.activeUsers': '活跃用户',
  'dashboard.monitor.totalTransactions': '总交易额',
  'dashboard.monitor.salesVolume': '销售额',
  'dashboard.monitor.visits': '访问量',
  'dashboard.monitor.payments': '支付笔数',
  'dashboard.monitor.operationalEffect': '运营效果',
  'dashboard.monitor.efficiency': '效率',

  'dashboard.workplace.title': '工作台',
  'dashboard.workplace.welcome': '早安',
  'dashboard.workplace.goodMorning': '早安',
  'dashboard.workplace.goodAfternoon': '下午好',
  'dashboard.workplace.goodEvening': '晚安',
  'dashboard.workplace.projectNotice': '项目动态',
  'dashboard.workplace.quickStart': '快速开始 / 便捷导航',
  'dashboard.workplace.conversionMarketingAmount': '转化率',
  'dashboard.workplace.dailyViews': '日访问量',
  'dashboard.workplace.team': '团队',
  'dashboard.workplace.introduce': '指标说明',

  // 页面标题和说明
  'pages.dashboard.text': '无缝接入门店管理生态，提供远程积分管理解决方案。',
  'pages.dashboard.storeTitle': '门店',
  'pages.dashboard.management.title': '总部管理',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': '显示会员注册二维码',
  'pages.dashboard.qrcode.title': '会员注册二维码',
  'pages.dashboard.qrcode.download': '下载二维码',
  'pages.dashboard.qrcode.close': '关闭',

  // 其他已有文本
  'pages.dashboard.tooltip.members': '会员管理',
  'pages.dashboard.tooltip.cards': '礼品卡',
  'pages.dashboard.tooltip.coupons': '优惠券',
  'pages.dashboard.tooltip.orders': '订单',

  'pages.dashboard.userApp.management.title': '用户 App 管理',
  'pages.dashboard.userApp.posters.button': '宣传海报',
  'pages.dashboard.userApp.posters.title': '宣传海报管理',
  'pages.dashboard.userApp.posters.add': '添加海报',
  'pages.dashboard.userApp.posters.edit': '编辑海报',
  'pages.dashboard.userApp.posters.noPermission.title': '无权限',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    '你无权访问该总部的用户 App 宣传海报管理。',
  'pages.dashboard.userApp.posters.upload.imageTypeError': '只能上传 jpg、png 或 webp 图片',
  'pages.dashboard.userApp.posters.upload.sizeError': '图片不能超过 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': '请上传海报图片',
  'pages.dashboard.userApp.posters.message.saveSuccess': '保存成功',
  'pages.dashboard.userApp.posters.message.deleteSuccess': '删除成功',
  'pages.dashboard.userApp.posters.empty.all': '暂无海报',
  'pages.dashboard.userApp.posters.empty.carousel': '暂无顶部滚动海报',
  'pages.dashboard.userApp.posters.empty.static': '暂无静态海报',
  'pages.dashboard.userApp.posters.delete.confirm': '确认删除这张海报？',
  'pages.dashboard.userApp.posters.delete.ok': '删除',
  'pages.dashboard.userApp.posters.delete.cancel': '取消',
  'pages.dashboard.userApp.posters.type.carousel': '滚动翻页海报',
  'pages.dashboard.userApp.posters.type.static': '静态海报',
  'pages.dashboard.userApp.posters.sort': '排序',
  'pages.dashboard.userApp.posters.section.carousel': '顶部滚动海报',
  'pages.dashboard.userApp.posters.section.static': '静态海报',
  'pages.dashboard.userApp.posters.form.title': '海报标题',
  'pages.dashboard.userApp.posters.form.title.required': '请输入海报标题',
  'pages.dashboard.userApp.posters.form.title.placeholder': '例如：周末狂欢购',
  'pages.dashboard.userApp.posters.form.displayType': '海报类型',
  'pages.dashboard.userApp.posters.form.displayType.required': '请选择海报类型',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    '滚动翻页海报（顶部自动轮播，建议 1536 x 860）',
  'pages.dashboard.userApp.posters.form.displayType.static':
    '静态海报（下方列表，建议 1536 x 560）',
  'pages.dashboard.userApp.posters.form.sortOrder': '滚动顺序',
  'pages.dashboard.userApp.posters.form.sortOrder.required': '请选择滚动顺序',
  'pages.dashboard.userApp.posters.form.sortOrder.page': '第 {value} 页',
  'pages.dashboard.userApp.posters.form.image': '海报图片',
  'pages.dashboard.userApp.posters.form.image.replace': '替换图片（可选）',
  'pages.dashboard.userApp.posters.form.image.select': '选择图片',
  'pages.dashboard.userApp.posters.scope.common': '通用海报',
  'pages.dashboard.userApp.posters.scope.store': '门店海报',
  'pages.dashboard.userApp.posters.store.placeholder': '请选择门店',
  'pages.dashboard.userApp.posters.store.viewOnly': '仅可查看——需要门店海报管理权限',
};
